import { Table } from '@themesberg/react-bootstrap'
import React from 'react'
import PaginationComponent from '../Pagination'
import { AMOUNT_TYPE, statusType, tableHeaders } from '../../pages/Super-Admin/CasinoTransactions/constants'
import { getDateTime, convertToEasternFormat } from '../../utils/dateFormatter'
import Trigger from '../OverlayTrigger'


const SportsBookTransactionList = ({
  setPage,
  page,
  totalPages,
  limit,
  setLimit,
  transactions,
  isTenant,
  loading = false,
  paginationRef,
  tableMaxHeight,
  visibleColumns = [],
  istoggleColumn = false,
  type,
  sportsBookTransactionTypes,
  showTotalCount = false,
  totalCount,
  countText
}) => {
  const tenantHeader = [
    'ID',
    'User Email',
    'Game Name',
    // 'Action Type',
    'Amount',
    'Before Balance',
    'After Balance',
    // 'Bonus Money',
    'Status',
    'Created At'
  ]
  console.log({ transactions }, "transactionstransactions")
  const renderCell = (col, txn) => {
    const key = col.accessor

    switch (key) {
      case 'id':
        return txn.id

      case 'email':
        return (
          <Trigger message={txn?.User?.email}>
            <span
              style={{ width: '130px', cursor: 'pointer' }}
              className='d-inline-block text-truncate'
            >
              {txn?.User?.email}
            </span>
          </Trigger>
        )

      case 'username':
        return (
          <Trigger message={txn?.User?.username}>
            <span
              style={{ width: '130px', cursor: 'pointer' }}
              className='d-inline-block text-truncate'
            >
              {txn?.User?.username}
            </span>
          </Trigger>
        )

      case 'gameReference':
        return (
          <Trigger message={txn?.gameReference}>
            <span
              style={{ width: '120px', cursor: 'pointer' }}
              className='d-inline-block text-truncate'
            >
              {txn?.gameReference}
            </span>
          </Trigger>
        )

      case 'events':
        return (
          <Trigger message={txn?.BetsBetslip?.events}>
            <span
              style={{ width: '200px', cursor: 'pointer' }}
              className='d-inline-block text-truncate'
            >
              {txn?.BetsBetslip?.events || "-"}
            </span>
          </Trigger>
        )

      case 'amount':
        return (
          <span className={`text-right ${txn.amount > 0 ? 'text-success' : txn.amount < 0 ? 'text-danger' : ''}`}>
            {`${txn.amount} ${txn?.User?.currencyCode}`}
          </span>
        )

      case 'Odds':
        return (
          txn?.BetsBetslip?.odds != null
            ? Number(txn.BetsBetslip.odds).toFixed(3)
            : "-"

        )

      case 'amountType':
        return AMOUNT_TYPE[txn.amountType]


      case 'transactionType':
        return sportsBookTransactionTypes[txn.purpose] || txn.purpose || "-" // currentBalance

      case 'currentBalance':
        return txn.currentBalance || "-" // currentBalance

      case 'betslipStatus':
        return txn?.BetsBetslip?.betslipStatus || "-" // betMode
      case 'nonCashAmount':
        return txn?.nonCashAmount || "-" // currentBalance  nonCashAmount  stake

      case 'betMode':
        return txn?.BetsBetslip?.betMode || "-"

      case 'stake':
        return txn?.BetsBetslip?.stake || "-"

      case 'betslipStatus':
        return txn?.BetsBetslip?.betslipStatus || "-" // betMode

      case 'referenceNumber':
        return txn.referenceNumber || "-" // bonusMoney

      case 'status':
        return txn.status // or map to label if you have statusType mapping

      case 'createdAt':
        return convertToEasternFormat(txn.createdAt)

      default:
        return '-'
    }
  }

  return (
    <div className="CustomTableWrapper">
      <div className="table-scroll-wrapper" style={{ maxHeight: tableMaxHeight }}>
        <div className="table-responsive" id={type}>
          <Table striped hover size='sm' className='text-center mt-3'>
            <thead className='thead-light'>
              <tr>
                {istoggleColumn
                  ? visibleColumns.map((col) => (
                    <th key={col.accessor} className={`${['Amount', 'Bonus Money'].includes(col.Header) && transactions?.count > 0 ? '' : ''}`}>
                      {col.Header}
                      {col.isTooltipEnabled && (
                        <i
                          className="fa fa-info-circle ms-2"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"   // Tooltip on top
                          title={`${col.tooltip}`}
                        />
                      )}
                    </th>
                  ))
                  : isTenant
                    ? tenantHeader.map((c) => (
                      <th key={c}>{c}</th>
                    ))
                    : tableHeaders.map((c) => (
                      <th key={c} className={`${['Amount', 'Bonus Money'].includes(c) && transactions?.count > 0 ? 'text-right' : ''}`}>{c}</th>
                    ))}
              </tr>
            </thead>

            <tbody id={loading ? 'cover-spin' : ''}>
              {transactions && !loading &&
                transactions?.rows?.map((txn) => {
                  const {
                    casinoTransactionId,
                    User,
                    createdAt,
                    gameIdentifier,
                    actionType,
                    amount,
                    amountType,
                    status,
                    nonCashAmount,
                    beforeBalance,
                    afterBalance,
                  } = txn;

                  return (
                    <tr key={`casino-transaction-list ${casinoTransactionId}`}>
                      {istoggleColumn
                        ? visibleColumns.map((col) => (
                          <td key={col.accessor} className={`${['amount', 'beforeBalance', 'afterBalance'].includes(col.accessor) ? '' : ''}`}>
                            {renderCell(col, txn)}
                          </td>
                        ))
                        : isTenant
                          ? (
                            <>
                              <td>{casinoTransactionId}</td>
                              <td>
                                <Trigger message={User?.email}>
                                  <span
                                    style={{
                                      width: '130px',
                                      cursor: 'pointer'
                                    }}
                                    className='d-inline-block text-truncate'
                                  >
                                    {User?.email}
                                  </span>
                                </Trigger>
                              </td>
                              <td>
                                <Trigger message={gameIdentifier}>
                                  <span
                                    style={{
                                      width: '120px',
                                      cursor: 'pointer'
                                    }}
                                    className='d-inline-block text-truncate'
                                  >
                                    {gameIdentifier}
                                  </span>
                                </Trigger>
                              </td>
                              <td className={`text-right ${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${amount} ${User?.currencyCode}`}
                              </td>
                              <td className={`${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${beforeBalance} ${User?.currencyCode}`}
                              </td>
                              <td className={`${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${afterBalance} ${User?.currencyCode}`}
                              </td>
                              <td>{status}</td>
                              <td>{getDateTime(createdAt)}</td>
                            </>
                          )
                          : (
                            <>
                              <td>{casinoTransactionId}</td>
                              <td>
                                <Trigger message={User?.email}>
                                  <span
                                    style={{
                                      width: '130px',
                                      cursor: 'pointer'
                                    }}
                                    className='d-inline-block text-truncate'
                                  >
                                    {User?.email}
                                  </span>
                                </Trigger>
                              </td>
                              <td>
                                <Trigger message={gameIdentifier}>
                                  <span
                                    style={{
                                      width: '120px',
                                      cursor: 'pointer'
                                    }}
                                    className='d-inline-block text-truncate'
                                  >
                                    {gameIdentifier}
                                  </span>
                                </Trigger>
                              </td>
                              <td>
                                <Trigger message={actionType}>
                                  <span
                                    style={{
                                      width: '120px',
                                      cursor: 'pointer'
                                    }}
                                    className='d-inline-block text-truncate'
                                  >
                                    {actionType}
                                  </span>
                                </Trigger>
                              </td>
                              <td className={`text-right ${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${amount} ${User?.currencyCode}`}
                              </td>
                              <td>
                                {AMOUNT_TYPE[amountType]}
                              </td>
                              <td className={`${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${beforeBalance} ${User?.currencyCode}`}
                              </td>
                              <td className={`${amount > 0 ? 'text-success' : amount < 0 && 'text-danger'}`}>
                                {`${afterBalance} ${User?.currencyCode}`}
                              </td>
                              <td>{getDateTime(createdAt)}</td>
                            </>
                          )}
                    </tr>
                  )
                })}
              {transactions?.count === 0 && !loading && (
                <tr>
                  <td colSpan={istoggleColumn && visibleColumns.length > 0 ? visibleColumns.length : (isTenant ? 8 : 9)} className='text-danger text-center'>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {transactions?.count > 0 && !loading && (
        <div className="pagination-wrapper" ref={paginationRef} >
          <PaginationComponent
            page={transactions?.count < page ? setPage(1) : page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            showTotalCount={showTotalCount}
            totalCount={totalCount}
            countText={countText}
          />
        </div>
      )}

    </div>
  )
}

export default SportsBookTransactionList
